import { ShieldCheck } from "lucide-react";

/**
 * Small trust badge shown near checkout CTAs.
 *
 * Uses generic "secure checkout · Stripe" wording + a shield icon in Stripe's
 * signature purple (#635BFF) — communicates the payment processor without
 * misusing the Stripe wordmark logo.
 *
 * Variants:
 *   • `mini`     — pill-style badge that sits directly under a CTA (default)
 *   • `caption`  — quieter one-liner for footer-style placement
 */
export function StripeTrustBadge({ variant = "mini", className = "" }) {
  if (variant === "caption") {
    return (
      <div
        className={`flex items-center justify-center gap-1.5 text-[10px] font-mono-tactical tracking-[0.25em] uppercase text-white/40 ${className}`}
        data-testid="stripe-trust-badge"
      >
        <ShieldCheck size={11} className="text-[#635BFF]" />
        Secure checkout · Powered by Stripe
      </div>
    );
  }
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 border border-white/15 bg-white/[0.03] text-[10px] font-mono-tactical tracking-[0.22em] uppercase text-white/70 ${className}`}
      data-testid="stripe-trust-badge"
    >
      <ShieldCheck size={12} className="text-[#635BFF]" />
      Secure · <span className="text-white">Stripe</span> checkout
    </div>
  );
}

export default StripeTrustBadge;
